import { cn } from "@/lib/utils";

export function Separator({
  className,
  height = "h-8",
}: {
  className?: string;
  height?: string;
}) {
  const heightClasses = {
    "h-2": "h-2 before:h-2",
    "h-4": "h-4 before:h-4",
    "h-6": "h-6 before:h-6",
    "h-8": "h-8 before:h-8",
    "h-10": "h-10 before:h-10",
    "h-12": "h-12 before:h-12",
  };

  const heightClass =
    heightClasses[height as keyof typeof heightClasses] || "h-8 before:h-8";

  return (
    <div
      className={cn(
        "relative flex w-full",
        heightClass,
        "before:absolute before:-left-[100vw] before:-z-1 before:w-[200vw]",
        "before:bg-[repeating-linear-gradient(315deg,var(--pattern-foreground)_0,var(--pattern-foreground)_1px,transparent_0,transparent_50%)] before:bg-size-[10px_10px] before:[--pattern-foreground:var(--color-edge)]/56",
        "after:absolute after:bottom-0 after:-left-[100vw] after:-z-1 after:h-px after:w-[200vw] after:bg-edge",
        className
      )}
    />
  );
} 